export class CrossChainDeploymentStoreError extends Error {
  // This gives the error type safety
  private readonly typeName = 'CrossChainDeploymentStoreError'
  public readonly name = this.typeName

  constructor(message: string) {
    super(`Error in the CrossChainDeploymentStore: ${message}`)
  }
}
